import { render } from "./ExperimentDetailPage.vue?vue&type=template&id=50cddc32&scoped=true"
import script from "./ExperimentDetailPage.vue?vue&type=script&lang=js"
export * from "./ExperimentDetailPage.vue?vue&type=script&lang=js"

import "./ExperimentDetailPage.vue?vue&type=style&index=0&id=50cddc32&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50cddc32"]])

export default __exports__